import { useBusinessStore } from '@register-ui/utils';

export function BusinessBrand() {
    const { businessInfo } = useBusinessStore();

    return (
        <div>
            {businessInfo?.businessLogo ? (
                <img
                    className='mx-auto mb-16 h-48 w-150 object-contain'
                    src={businessInfo?.businessLogo}
                    alt={businessInfo.businessName}
                />
            ) : (
                <h1 className='mb-16 text-18 font-semibold leading-none text-content-heading-default'>
                    {businessInfo?.businessName}
                </h1>
            )}

            <p className='text-base font-medium leading-none text-content-subtext-default'>
                {businessInfo?.branchName}
            </p>
        </div>
    );
}
